/**
 * Created by r4zi4l on 04.07.2022
 */

const OrderDetails = cc.Scale9Sprite.extend({
    ctor: function (orders) {
        const styles = cleverapps.styles.OrderDetails;
        const background = bundles.orderswindow.frames.orders_background;

        this._super(background, cleverapps.UI.getScale9Rect(background, cleverapps.UI.Scale9Rect.TwoPixelXY));

        this.orders = orders;
        this.maker = orders.getCurrentMaker();

        this.setContentSize2(styles);

        if (bundles.windows.frames.details_rings) {
            styles.rings.forEach(function (style) {
                const ring = new cc.Sprite(bundles.windows.frames.details_rings);
                ring.setAlignment(style);
                this.addChild(ring);
            }, this);
        }

        const required = cleverapps.UI.generateOnlyText(Messages.get("OrderDetails.required"), cleverapps.styles.FONTS.HERODETAILS_TEXT);
        required.setAlignment(styles.required);
        this.addChild(required);

        this.createHeroIcon();
        this.hungryTimer = this.createHungryTimer();
        this.createIngredients();
        this.createButton();

        this.orders.on("makerSelected", this.updateMaker.bind(this), this);
        this.orders.on("orderStateChanged", this.updateOrder.bind(this), this);
        this.orders.on("orderStateChanged", this.updateIngredients.bind(this), this);
    },

    createHeroIcon: function () {
        const styles = cleverapps.styles.OrderDetails.heroIcon;

        const unit = this.maker && this.maker.unit || { code: "dwarf", stage: 1 };

        const heroIcon = this.heroIcon = new HeroIcon(unit);
        heroIcon.setOpened(true);
        heroIcon.showSelection();
        heroIcon.setAlignment(styles);
        heroIcon.setScale(styles.scale);
        this.addChild(heroIcon);
    },

    createHungryTimer: function () {
        const hungryGamesCustomer = this.maker && this.maker.unit.findComponent(HungryGamesCustomer);

        if (!hungryGamesCustomer || !hungryGamesCustomer.hasLevelTimer() || this.maker.getState() !== Customer.STATE_RECIPE) {
            return undefined;
        }

        const styles = cleverapps.styles.OrderDetails.hungryTimer;

        const background = cleverapps.UI.createScale9Sprite(bundles.orderswindow.frames.details_timer_hungry, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setContentSize2(styles);
        background.setAnchorPoint(0.5, 0.5);
        background.setAlignment(styles);
        this.addChild(background);

        const text = new cleverapps.CountDownView(new cleverapps.CountDown(hungryGamesCustomer.getTimeLeft()), {
            font: cleverapps.styles.FONTS.ORDERDETAILS_HUNGRY_TIMER_TEXT
        });
        text.setAnchorPoint(0.5, 0.5);
        text.setAlignment(styles.text);
        background.addChild(text);

        return background;
    },

    createButton: function () {
        const styles = cleverapps.styles.OrderDetails.button;

        let Button = cleverapps.UI.Button;
        const buttonOptions = {
            width: styles.width,
            height: styles.height,
            onClicked: this.orders.processOrder.bind(this.orders, this.maker)
        };

        switch (this.maker && this.maker.getState()) {
            case Customer.STATE_RECIPE:
                if (this.maker.canCook()) {
                    buttonOptions.text = Messages.get("OrdersWindow.button.make");
                } else if (typeof HungryGamesCustomer !== "undefined" && this.maker.unit.findComponent(HungryGamesCustomer)) {
                    buttonOptions.text = Messages.get("OrdersWindow.button.make");
                    buttonOptions.disabled = true;
                } else {
                    buttonOptions.text = this.orders.getBuyIngredientsText(this.maker);
                }
                break;

            case Customer.STATE_READY:
                buttonOptions.text = Messages.get("Claim");
                break;

            case Customer.STATE_COOKING:
                Button = UseGoldButton;

                buttonOptions.canCoins = true;
                buttonOptions.price = Unit.CalcSpeedUPPrice(this.maker.getCookingTimeLeft());
                buttonOptions.freeIcon = TextWithIcon.ICONS_BY_NAME.speedup;
                buttonOptions.eventName = cleverapps.EVENTS.SPENT.ORDER;
                buttonOptions.speedUp = true;
                buttonOptions.type = cleverapps.styles.UI.Button.Images.button_blue;

                if (ConfirmSpeedUpWindow.isAvailable(buttonOptions.price)) {
                    buttonOptions.confirmWindowOptions = {
                        timeLeft: this.maker.getCookingTimeLeft(),
                        totalDuration: this.maker.recipe.cookingDuration
                    };
                }
                break;

            default:
                buttonOptions.disabled = true;
                buttonOptions.text = Messages.get("OrdersWindow.button.make");
        }

        const button = this.button = new Button(buttonOptions);
        button.setAlignment(styles);
        this.addChild(button);

        if (Map2dLocation.currentLocation.tutorial.isActive() || cleverapps.tutorial.isActive() || this.maker && this.maker.getState() === Customer.STATE_READY) {
            button.runAction(new cc.Sequence(
                new cc.DelayTime(Map2dLocation.currentLocation.tutorial.isActive() || cleverapps.tutorial.isActive() ? 0.3 : 2.5),
                new cc.CallFunc(() => {
                    FingerView.hintTap(button, {
                        delay: 2.5,
                        repeatDelay: 2.5
                    });
                })
            ));
        }
    },

    createIngredients: function () {
        if (!this.maker) {
            return;
        }

        const styles = cleverapps.styles.OrderDetails.ingredients;
        const icons = this.maker.recipe.ingredients.concat([undefined, undefined, undefined]).slice(0, 3).map(function (ingredient) {
            return new IngredientOrderIcon(ingredient, this.maker);
        }, this);

        const ingredientsBackgrounds = icons.map((icon) => {
            const ingredientsBackground = cleverapps.UI.createScale9Sprite(bundles.orderswindow.frames.ingredients_background, cleverapps.UI.Scale9Rect.TwoPixelXY);
            ingredientsBackground.setContentSize2(icon.width, icon.height);
            return ingredientsBackground;
        });

        const ingredientsBackgroundsLayout = this.ingredientsBackgrounds = new cleverapps.Layout(ingredientsBackgrounds, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
        ingredientsBackgroundsLayout.setAlignment(styles);
        this.addChild(ingredientsBackgroundsLayout);

        const ingredients = this.ingredients = new cleverapps.Layout(icons, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
        ingredients.setAlignment(styles);
        this.addChild(ingredients);
    },

    changeHeroIcon: function () {
        if (this.heroIcon) {
            this.heroIcon.removeFromParent();
        }
        this.createHeroIcon();
    },

    changeHungryTimer: function () {
        if (this.hungryTimer) {
            this.hungryTimer.removeFromParent();
            this.hungryTimer = undefined;
        }
        this.hungryTimer = this.createHungryTimer();
    },

    changeButton: function () {
        this.button.removeFromParent();
        this.createButton(this.maker);
    },

    changeIngredients: function () {
        if (this.ingredients) {
            this.ingredients.removeFromParent();
            this.ingredients = undefined;

            this.ingredientsBackgrounds.removeFromParent();
            this.ingredientsBackgrounds = undefined;
        }

        this.createIngredients();
    },

    updateMaker: function (maker) {
        if (maker === this.maker) {
            return;
        }
        this.maker = maker;

        this.changeHeroIcon();
        this.changeButton();
        this.changeHungryTimer();
        this.changeIngredients();
    },

    updateOrder: function (maker) {
        if (this.maker === maker) {
            this.changeButton();
            this.changeHungryTimer();
        }
    },

    updateIngredients: function () {
        const canCook = this.maker && this.maker.canCook();
        if (this.canCook !== canCook) {
            this.canCook = canCook;
            this.changeButton();
        }

        if (this.maker && this.maker.getState() === Customer.STATE_RECIPE) {
            this.ingredients.children.forEach((ingredient) => {
                ingredient.updateAmount();
            });
        }
    },

    removeAnimated: function (node) {
        node.children.forEach((child) => {
            if (child.beforeRemoveAnimated) {
                child.beforeRemoveAnimated();
            }
        });

        node.setCascadeOpacityEnabledRecursively(true);
        node.runAction(new cc.Spawn(
            new cc.FadeOut(0.4),
            new cc.Sequence(
                new cc.ScaleTo(0.3, 0.5).easing(cc.easeIn(2)),
                new cc.RemoveSelf()
            )
        ));
    },

    showAnimated: function (node) {
        node.setCascadeOpacityEnabledRecursively(true);
        node.setScale(0.8);
        node.setOpacity(0.3);

        node.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            new cc.Spawn(
                new cc.FadeIn(0.4),
                new cc.ScaleTo(0.3, 1)
            )
        ));
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ORDERDETAILS_HUNGRY_TIMER_TEXT: {
        size: 32,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: undefined,
        shadow: undefined
    }
});

cleverapps.styles.OrderDetails = {
    width: 660,
    height: 820,

    rings: [{
        x: { align: "left", dx: 90 },
        y: { align: "top", dy: -10 }
    }, {
        x: { align: "right", dx: -90 },
        y: { align: "top", dy: -10 }
    }],

    heroIcon: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 200 },
        scale: 0.9
    },

    hungryTimer: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 80 },
        width: 190,
        height: 65,

        text: {
            x: { align: "center" },
            y: { align: "center", dy: 2 }
        }
    },

    required: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 }
    },

    ingredients: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -130 },
        margin: 28
    },

    button: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -295 },
        width: 300,
        height: 110
    }
};
